jQuery(document).ready(function ($) {

    AOS.init({
        once: true
    });
    
    setTimeout(function() {
        AOS.init({
            once: true,
        });
    }, 100);
   
})